var module = angular.module('octopusApp.projects');

module.controller('ProjectVariablesLibraryController', function ($scope, $timeout, busy, projectState, pageTitle, octopusRepository, $location, unsavedChanges, $uibModal) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    $scope.configureLibraryVariableSets = configureLibraryVariableSets;
    $scope.save = save;

    function init() {
        $scope.showRemovedVariableSetWarning = false;
        isLoading.promise(projectState.load().then(function (project) {
            pageTitle(project.Name + " variables");
            $scope.project = project;
            updateIncludedSets();
        }));
    }

    function save() {
        isSaving.promise(octopusRepository.Projects.modify($scope.project).then(function () {
            unsavedChanges.saved();
            init();
        }));
    }

    function updateIncludedSets() {
        isLoading.promise(octopusRepository.LibraryVariableSets.all({ids: $scope.project.IncludedLibraryVariableSetIds, contentType: 'Variables'}).then(function (libraryVariableSets) {
            $scope.includedSets = libraryVariableSets;
            $scope.libraryVariableSetCount = libraryVariableSets.length;
        }));
    }

    function configureLibraryVariableSets() {

        var originalVariableSetIds = $scope.project.IncludedLibraryVariableSetIds;

        $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/projects/views/include_variables_dialog.html',
            controller: 'ProjectVariablesIncludeController',
            resolve: {
                current: function () {
                    return _.toArray($scope.project.IncludedLibraryVariableSetIds);
                },
                contentType: function () {
                    return 'Variables';
                },
                contentTypeDesc: function () {
                    return 'Variable Set';
                }
            }
        }).result.then(function (result) {
            if (result) {
                if (!_.isEqual(result, $scope.project.IncludedLibraryVariableSetIds)) {

                    var variableSetsIdsRemoved = _.difference(originalVariableSetIds, result);
                    $scope.showRemovedVariableSetWarning = variableSetsIdsRemoved.length > 0;

                    $scope.project.IncludedLibraryVariableSetIds = _.toArray(result);
                    unsavedChanges.unsaved();
                    return updateIncludedSets();
                }
            }
        });
    }

    init();
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/variables/project_variables_library.js
// module id = 577
// module chunks = 1